/* eslint-disable import/prefer-default-export */
import * as CategoryIcons from '../components/icons';

export function CategoryIconMapper(category) {
  switch (category) {
    case 'business':
      return CategoryIcons.default.business;

    case 'psychology':
      return CategoryIcons.default.psychology;

    case 'personal-development':
      return CategoryIcons.default.personalDevelopment;

    case 'science':
      return CategoryIcons.default.science;

    case 'philosophy':
      return CategoryIcons.default.philosophy;

    case 'economics':
      return CategoryIcons.default.economics;

    case 'history':
      return CategoryIcons.default.history;

    case 'communication':
      return CategoryIcons.default.communication;

    case 'sociology':
      return CategoryIcons.default.sociology;

    case 'biographies-and-memoirs':
      return CategoryIcons.default.biographiesAndMemories;

    case 'health':
      return CategoryIcons.default.health;

    case 'self-help':
      return CategoryIcons.default.selfHelp;

    case 'technology':
      return CategoryIcons.default.technology;

    case 'politics':
      return CategoryIcons.default.politics;

    case 'fiction':
      return CategoryIcons.default.fiction;

    case 'management-and-leadership':
      return CategoryIcons.default.managementAndLeadership;

    case 'education':
      return CategoryIcons.default.education;

    case 'entrepreneurship':
      return CategoryIcons.default.entrepreneurship;

    case 'productivity':
      return CategoryIcons.default.productivity;

    case 'fitness':
      return CategoryIcons.default.fitness;
    default:
      return CategoryIcons.default.general;
  }
}
